import { BuyerGroup } from '../../../types';

export const SplitScenarioAction = {
  FETCH_SPLITSCENARIO: 'FETCH_SPLITSCENARIO',
  SHOW_SPLITSCENARIO: 'SHOW_SPLITSCENARIO',
  HIDE_SPLITSCENARIO: 'HIDE_SPLITSCENARIO', //jeds
  UPDATE_SPLITSCENARIO_ITEM: 'UPDATE_SPLITSCENARIO_ITEM',
  SAVE_SPLITSCENARIO: 'SAVE_SPLITSCENARIO',
  UPDATE_SPLITSCENARIO_LIST: 'UPDATE_SPLITSCENARIO_LIST',
  DELETE_SPLITSCENARIO: 'DELETE_SPLITSCENARIO',
  CLONE_SPLITSCENARIO: 'CLONE_SPLITSCENARIO',
  BUYERGROUP_SPLITSCENARIO: 'BUYERGROUP_SPLITSCENARIO',
  GET_SIGNUP_COLUMNS: 'GET_SIGNUP_COLUMNS',
};

export const SplitScenarioModalAction = {
  CREATE: 'MODAL_CREATE',
  EDIT: 'MODAL_EDIT',
  DELETE: 'MODAL_DELETE',
};

export const SplitScenarioURL = {
  REVIEW: '/api/SplitScenario/Get',
  GETBYID: '/api/SplitScenario/Get',
  CREATE: '/api/SplitScenario/Add',
  UPDATE: '/api/SplitScenario/Update',
  DELETE: '/api/SplitScenario/Delete',
  BUYERGROUP: 'api/Splitscenario/BuyerGroups',
};

export const EmptyBuyerGroup: BuyerGroup = {
  BuyerGroupId: 0,
  BuyerId: 0,
  BuyerGroupName: '',
  BuyerName: '',
  PascalFilterValue: [],
  FilterValue: [],
  ZipCodeFilterValue: [],
  DeleteZipCodeFilters: [],
  DailyCap: 0,
  IsActive: false,
  IsArchived: false,
  IsDefault: false,
  TcpaContent: '',
  TcpaId: 0,
  TcpaType: '',
  TcpaCompany: '',
  ThankYouPageURL: '',
  CakeInstance: '',
  CkmBuyerContractId: '',
  Vertical: null,
};
